<template>
  <div class="widget white_box">
    <div class="widget_header">
      <h3 class="tw-text-neutral-900 tw-text-2xl">
        Average Keyword Ranking
      </h3>
      <DefaultButton
        v-if="!editing && !preview"
        size="small"
        as="a"
        href="/keywords?modal=ranking"
      >
        See more
      </DefaultButton>
      <div
        v-if="editing && !preview"
        class="edit_buttons"
      >
        <DefaultButton
          size="small"
          variant="danger"
          @click="$parent.remove(widget)"
        >
          Delete
        </DefaultButton>
      </div>
    </div>
    <apexchart
      v-if="!loading"
      :options="chartOptions"
      :series="series"
      height="300"
      type="line"
    />

    <div
      v-else
      class="loading_widget_data"
    >
      <i class="fa fa-btn fa-spinner fa-spin" /> Loading Data
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import axios from 'axios';
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";

export default {
  components: {
    DefaultButton,
  },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      series: [{
        name: "Average Ranking",
        data: []
      }],
      options: {
        colors: ['#0c9bef', '#969696'],
        xaxis: {
          categories: [],
          type: 'datetime',
        },
        yaxis: [{
          reversed: true,
          min: 1,
          max: 100,
          forceNiceScale: true,
          labels: {
            formatter: (value) => Math.round(value),
          }
        }],
        tooltip: {
          x: {
            format: 'd MMM yyyy',
          }
        }
      }
    }
  },
  computed: {
    ...mapState('dashboard', ['chartBaseOptions', 'uuid', 'preview']),
    chartOptions() {
      return {
        ...this.chartBaseOptions,
        ...this.options
      };
    }
  },
  async mounted() {
    const { data } = await axios.post('/ajax/dashboard/get-widget-data', {
      type: 'averageKeywordRanking',
      uuid: this.uuid,
    });

    let average = data.average;
    this.series[0].data = average.data;

    const values = average.data.filter(value => typeof value === 'number' && !isNaN(value));
    const yAxis = this.options.yaxis[0];

    let min = yAxis.min;
    let max = yAxis.max;

    if (values.length > 0) {
      const dataMin = Math.min(...values);
      const dataMax = Math.max(...values);
      min = Math.max(min, dataMin - 5);
      max = Math.min(max, dataMax + 5);
    }

    this.options = {
      ...this.options,
      xaxis: {
        ...this.options.xaxis,
        categories: average.labels,
      },
      yaxis: [{
        ...yAxis,
        min: min,
        max: max,
        labels: {
          formatter: (value) => Math.round(value),
        }
      }],
    }

    this.loading = false;
  },
}
</script>
